import { CAServices } from "../../services/trading-services"

export const CAActions = {
    getShareHoldersEquityAction,
    shareHoldersEquityConfirmAction,
    enquiryShareHoldersEquityAction,
    inputShareHoldersEquityAction
}

function getShareHoldersEquityAction(params, callback) {
    return () => {
        CAServices.getShareHoldersEquityService(params, res => {
            callback(res)
        })
    }
}

function shareHoldersEquityConfirmAction(params, callback) {
    return () => {
        CAServices.shareHoldersEquityConfirmService(params, res => {
            callback(res)
        })
    }
}

function enquiryShareHoldersEquityAction(params, callback) {
    return () => {
        CAServices.enquiryShareHoldersEquityService(params, res => {
            callback(res)
        })
    }
}

function inputShareHoldersEquityAction(params, callback) {
    return () => {
        CAServices.inputShareHoldersEquityService(params, res => {
            callback(res)
        })
    }
}